import searchHistoryTab from './searchHistoryTab';
import searchTab from './searchTab';
import searchesTab from './searchesTab';
import searchRunTab from './searchRunTab';
import newSearchTab from './newSearchTab';

export default [
  newSearchTab,
  searchesTab,
  searchHistoryTab,
  searchRunTab,
  searchTab,
];
